<template>
<v-img :width="size" :height="size" :src="srcCurtain" contain></v-img>
</template>

<script>
export default {
  name: 'Curtain',
  props: {
    size: {
      type: [Number, String],
      default: 120,
    },
    openPercent: {
      type: Number,
      default: 0
    },
    openDirection: {
      type: String
    }
  },
  data() {
    return {
      icon: {
        horizontal: {
          '0': require('@/assets/icon/curtain/curtain_horizontal_0.svg'),
          '25': require('@/assets/icon/curtain/curtain_horizontal_25.svg'),
          '50': require('@/assets/icon/curtain/curtain_horizontal_50.svg'),
          '75': require('@/assets/icon/curtain/curtain_horizontal_75.svg'),
          '100': require('@/assets/icon/curtain/curtain_horizontal_100.svg')
        },
        up: {
          '0': require('@/assets/icon/curtain/curtain_up_0.svg'),
          '10': require('@/assets/icon/curtain/curtain_up_10.svg'),
          '20': require('@/assets/icon/curtain/curtain_up_20.svg'),
          '30': require('@/assets/icon/curtain/curtain_up_30.svg'),
          '40': require('@/assets/icon/curtain/curtain_up_40.svg'),
          '50': require('@/assets/icon/curtain/curtain_up_50.svg'),
          '60': require('@/assets/icon/curtain/curtain_up_60.svg'),
          '70': require('@/assets/icon/curtain/curtain_up_70.svg'),
          '80': require('@/assets/icon/curtain/curtain_up_80.svg'),
          '90': require('@/assets/icon/curtain/curtain_up_90.svg'),
          '100': require('@/assets/icon/curtain/curtain_up_100.svg')
        }
      }
    }
  },
  computed: {
    srcCurtain() {
      let level = 0;
      switch (this.openDirection) {
        case 'IN':
        case 'OUT':
          level = ~~(this.openPercent / 25) * 25;
          return this.icon.horizontal[level];

        default:
          level = ~~(this.openPercent / 10) * 10;
          return this.icon.up[level];
      }
    }
  }
}
</script>
